import { SaleCashierPanel } from './SaleCashierPanel'

import type { OwnCashierSession } from '../model/useOwnCashier'

export interface OwnCashierPanelProps {
  session: OwnCashierSession
  /** Имя кассира незавершённой операции, если он не тот, кто выбран сейчас: повтор уйдёт на него. */
  retryCashierName?: string | null
}

/**
 * Связка окна кассира с экраном (RP-OWN11): состояние и правила — в `useOwnCashier`, вид — `SaleCashierPanel` пакета. Ошибка службы
 * Cashiers (ответ на код или на чтение списка) показывается дословно, с кодом, номером запроса и «Скопировать», и по таймеру не исчезает.
 */
export function OwnCashierPanel({ session, retryCashierName = null }: OwnCashierPanelProps) {
  const { list, problem, selected, grantedName, blockReason, verifying } = session
  const shown = problem ?? (list.status === 'error' ? list.problem : null)
  return (
    <SaleCashierPanel
      list={list.status === 'ready' ? { status: 'ready', items: list.items.map((item) => ({ id: item.sourceCashierId, name: item.name })) } : { status: list.status }}
      selectedId={selected?.sourceCashierId ?? null}
      grantedName={grantedName}
      verifying={verifying}
      problem={shown === null ? null : { text: shown.text, code: shown.code, correlationId: shown.correlationId }}
      blockReason={blockReason}
      copyText={shown?.report ?? blockReason}
      retryCashierName={retryCashierName}
      onSelect={session.select}
      onSubmitPin={(pin) => void session.verify(pin)}
      onReload={session.reload}
      onForget={session.forget}
    />
  )
}
